import { mapParamsBySchema } from '../../util';
import { apiRequest } from '../../Services/Common/ApiRequest';
import Global from '../../Services/Common/Global';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { handleQuerySuccess } from '../../Hooks/apis/useQuriesSuccess';
import useSaveMutation from '../../Hooks/apis/useSaveMutaion';
import { M_ALA_BASIC_Schema } from './M_ALA_BASIC_Schema';

export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(M_ALA_BASIC_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['Alarm', 'GetAlaBasicR1', params],
    queryFn: () => apiRequest('post', Global.urls.Alarm.GetAlaBasicR1, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

export const useSave1 = (options = {}) => {
  return useSaveMutation(async (context) => {
    console.log('useSave1', context);

    const payload = mapParamsBySchema(M_ALA_BASIC_Schema.mapper.save1, context);
    return apiRequest('post', Global.urls.Alarm.SaveAlaBasicSettingU1, payload);
  }, options);
};

export const useSave2 = (options = {}) => {
  return useSaveMutation(async (context) => {
    const payload = mapParamsBySchema(M_ALA_BASIC_Schema.mapper.save2, context);
    return apiRequest('post', Global.urls.Alarm.SaveAlaBasicSettingU2, payload);
  }, options);
};
